// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f022435e","68":"4387a8b3","141":"115d83b9","193":"8a375a70","246":"be43ee87","275":"35303b3c","368":"8ed4344b","395":"d1684f49","636":"0c1b2907","863":"acc5e0b6","896":"fc41fcf5","976":"33af695b","986":"011160c3"}[chunkId] + ".chunk.js";
};